import { Box, styled, Typography, useTheme } from "@mui/material";
import { Container } from "components/container";
import { RetroButton } from "components/RetroButton";
import { RetroCard } from "components/RetroCard";
import { Card, Col, Row } from "v2/components/base/Flex/ui";

const Footer = ({
  location,
  footerLogos,
  handleClick,
  ...props
}: {
  isShowFooter: boolean;
  location: Location;
  handleClick: (route: string) => void;
  footerLogos: {
    route: string;
    icon: JSX.Element;
    label: string;
  }[];
}) => {
  const theme = useTheme();

  return (
    <Row
      sx={{ position: "fixed", bottom: 0, width: "100%", backgroundColor: "transparent" }}
      fullWidth>
      <Card.Section
        sx={{ marginY: theme.spacing(1), width: "100%", backgroundColor: "transparent" }}
        {...props}>
        <Row
          type="cc"
          sx={{
            width: "100%",
            display: "flex",
            gap: "10px",
            // height: "66px",
            backgroundColor: `${theme.palette.surface.black} `,
            borderRadius: "16px",
            paddingY: "14px",
            maxWidth: "328px",
            marginX: "auto",
          }}
          fullWidth>
          {footerLogos.map(({ route, icon, label }) => {
            return (
              <Col
                type="bc"
                sx={{
                  flex: 1,
                  cursor: location.pathname === route ? "default" : "pointer",
                }}
                onClick={() => {
                  if (location.pathname === route) {
                    return;
                  }
                  handleClick(route);
                }}>
                <Typography
                  variant="mobile-action-xs-heavy"
                  sx={{
                    color: location.pathname === route ? "brand.primary" : "text.secondary",
                    transition: "color 0.3s ease",
                  }}>
                  {icon}
                </Typography>
                <Typography
                  variant="mobile-action-xs-heavy"
                  sx={{
                    fontSize: "10px",
                    lineHeight: "9px",
                    marginTop: theme.spacing(0.5),
                  }}
                  color={location.pathname === route ? "brand.primary" : "text.secondary"}>
                  {label}
                </Typography>
              </Col>
            );
          })}
        </Row>
      </Card.Section>
    </Row>
  );
};

export default Footer;
